import fetch from 'isomorphic-fetch'

const API_URL_AVT = process.env.REACT_APP_AVT_API_URL

const createRequestBody = (requestObj) => {
  return {
    method: requestObj.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestObj.body)
  }
}

const getParamByKey = async (key) => {
  const requestUrl = `${API_URL_AVT}/odin/api/param/${key}`

  const requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getParams = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/params`

  const requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

export { getParamByKey, getParams }
